<!-- <div @anim *ngIf="unika && !desktopResolution" class="right-side">
    <div class="logo-title-holder">
        <div *ngIf="compositeDesign" class="proj-comp-titles">
            <div>
                <app-gallery [galleryId]="'1'" [section]="compId + 'imagesCompLogo'" [autoPlay]="false"
                    [showThumbs]="false" class="logo-img comp-logo"></app-gallery> {{ this.companyTitle }}
            </div>
            <div>
                <app-gallery [galleryId]="'1'" [section]="projUid+'menuLogo'" [autoPlay]="false"
                    [showThumbs]="false" class="logo-img top-project-menu-logo"></app-gallery>
                {{ this.projectTitle }}
            </div>
        </div>
    </div>
</div> -->

<div @anim class="menu" [class.active]="showMenu || unika" [class.composite-design-menu]="compositeDesign"
    [class.remove-menu]="removeAllMenu">

    <div *ngIf="!unika" class="logo-title-holder">
        <app-gallery [galleryId]="'1'" [section]="projUid+'menuLogo'" [autoPlay]="false" [showThumbs]="false"
            class="logo-img top-project-menu-logo"></app-gallery>
        <div *ngIf="compositeDesign && desktopResolution" class="proj-comp-titles" (click)="goToProject()">
            <div> {{ this.companyTitle }} </div> - <span> {{ this.projectTitle }} </span>
        </div>
    </div>
    <div *ngIf="unika" class="right-side {{ this.classAlert }}">
        <div *ngIf="this.hoisUrl !== 'https://habaitproject.co.il'" class="spirikal-logo"><img src="assets/img/s.jpg"
                alt="spirikal logo"></div>
        <div *ngIf="this.hoisUrl === 'https://habaitproject.co.il'" class="spirikal-logo"><img src="assets/img/h.jpg"
                alt="habait logo"></div>
                <span *ngIf="projectlistToIncognito" class="button-to-map-incognito"><a href='javascript:;' (click)="navigatToMainPage()"></a></span>
        <div class="logo-title-holder">
            <div @slideUp *ngIf="compositeDesign" class="proj-comp-titles">
                <div *ngIf="this.showCompLogo">
                    <app-gallery  [galleryId]="'1'" [section]="compId + 'imagesCompLogo'"
                        [autoPlay]="false" [showThumbs]="false" class="logo-img comp-logo"></app-gallery> {{
                    this.companyTitle }}
                </div>
                <div>
                    <app-gallery [galleryId]="'1'" [section]="projUid+'menuLogo'" [autoPlay]="false"
                        [showThumbs]="false" class="logo-img top-project-menu-logo"></app-gallery>
                    <span *ngIf="this.showProjTitle"> {{ this.projectTitle }} </span>

                    <app-gallery [galleryId]="'1'" [section]="projUid+'addSomeContent'" [autoPlay]="false"
                                 [showThumbs]="false" class="logo-img addSomeContent"></app-gallery>
                </div>
            </div>

        </div>
        <span *ngIf="this.user">
            <div *ngIf="this.user.roles.admin"><button (click)="goToAdmin()">go to admin</button></div>
            <div *ngIf="projectlist && (this.user.roles.editor && this.user.compId === this.compId || this.user.roles.admin) && !projectlistToTheWorld"
                class="project-list-holder">
                <a href='javascript:;' class="menu-item title-button project-list" (click)="navigatToMainPage()"><span>
                        {{ 'HOME-PAGE' | translate }} </span></a>
            </div>
        </span>
        <div *ngIf="projectlist && projectlistToTheWorld" class="project-list-holder">
            <a href='javascript:;' class="menu-item title-button project-list" (click)="navigatToMainPage()"><span>
                    {{ 'HOME-PAGE' | translate }} </span></a>
        </div>
        <div *ngIf="this.proj?.date && supportPayment" [class.alert]="supportPayment"><span>נא להסדיר תשלום</span>
            <div>{{ this.proj.date | date:'dd'}}.{{this.proj.date | date:'MM'}}.{{this.proj.date | date:'yy'}}
            </div>
        </div>
    </div>
    <div *ngIf="multilang" class="lang-flags-holder">
        <div class="en" (click)="changeLanguage('en')"><img src="assets/img/en.png" alt="american flag"></div>
        <div class="he" (click)="changeLanguage('he')"><img src="assets/img/he.png" alt="israel flag"></div>
    </div>
    <!-- <app-user-profile *ngIf="showMenu && showAdminButton && (!desktopResolution || !unika)"></app-user-profile> -->
    <div *ngIf="desktopResolution && unika" class="left-side">
        <app-user-profile *ngIf="showMenu && showAdminButton"></app-user-profile>


        <div class="projects-menu-holder" *ngIf="this.projects && this.toggleProjListMenu && desktopResolution">
            <a [class.active]="toggleProjList" href="javascript:;" class="menu-item title-button project-list active"
                (click)="toggleProjListF()"> רשימת פרויקטים </a>
            <!-- <app-search-projects @slideUp [class.active]="toggleProjList" [showProperties]="true" [projects]="this.projects"
                class="search-panel-design"></app-search-projects> -->
            <app-search-projects @slideUpMenu *ngIf="toggleProjList" [showProperties]="true" [projects]="this.projects"
                class="search-panel-design"></app-search-projects>
            <div *ngIf="toggleProjList" class="close-list-background" (click)="toggleProjList = false"></div>
        </div>

        <div @anim class="current-date">{{ this.date | date:'dd'}}.{{this.date | date:'MM'}}.{{this.date | date:'yy'}}
        </div>

        <div *ngIf="this.weatherWidget.div && this.weatherWidget.id" class="weather-holder" [innerHtml]="this.weatherWidget.div | safe: 'html'">
        </div>


    </div>



    <div class="scroll-holder">
        <div class="menu-trigger closer-triger" (click)="showMenuF()" [class.hide]="removeAllMenu">
        </div>
        <div class="back-color"></div>
        <div class="project-menu" [class.active]="showMenu">
            <div class="logo-holder-project">
                <app-gallery [galleryId]="'1'" [section]="compId + 'logoonmenu'" [autoPlay]="false" [showThumbs]="false"
                    class="logo-img-proj"></app-gallery>
            </div>
            <div *ngIf="this.modulesArray[0]">
                <ul class="menu-items-holder">
                    <li *ngIf="modulesArray[0].currentSituationTitle && !unika" style="display: none;">
                        <div class="current-situation-holder">
                            <a [class.current]="currentSituation"
                                (mousedown)='openCurrentSituation($event, modulesArray[0].currentSituationTitle)'
                                href='javascript:;' class="menu-item title-button current-situation-trigger">
                            </a>
                            <div><span class="simulation-text">{{ 'SIMULATION' | translate }}</span><span
                                    class="current-situation-text">{{ 'CURRENT SITUATION' | translate }}</span></div>
                        </div>
                    </li>
                    <li>
                        <a *ngIf="!this.compositeDesign || !desktopResolution" (click)='goToProject()'
                            href='javascript:;' class="menu-item title-button home-show"><span>
                                {{ 'PROJ-HOME-PAGE' | translate }}
                            </span></a>
                    </li>
                    <li *ngIf="modulesArray[0].buildingsTitle && !unika">
                        <a (click)='openBuildings("buildMenu")' href='javascript:;'
                            class="menu-item title-button building-show" [class.active]='this.showBuildingSubMenu'
                            [class.dropdown-title]="compositeDesign"><span>{{ modulesArray[0].buildingsTitle
                                }}</span></a>
                        <!-- <app-building-list @slideUpMenu *ngIf="showBuildingSubMenu" -->
                        <app-building-list @slideUpMenu *ngIf="showBuildingSubMenu"
                            (showBuildingSubMenu)='openBuildings("buildMenuSub")' [projId]="this.projId"
                            [routeParams]="this.routeParams" [class.dropdown]="compositeDesign && desktopResolution">
                        </app-building-list>
                    </li>
                    <li *ngIf="modulesArray[0].floorsTitle && !unika">
                        <a (click)='openBuildings("floorMenu")' href='javascript:;'
                            class="menu-item title-button floors-show" [class.dropdown-title]="compositeDesign"
                            [class.active]='this.showFloorsViewSubMenu'><span>{{ modulesArray[0].floorsTitle
                                }}</span></a>
                        <app-views-from-floors-list [class.dropdown]="compositeDesign" @slideUpMenu
                            (showBuildingSubMenu)='openBuildings("floorMenuSub")' *ngIf="showFloorsViewSubMenu"
                            [projId]="this.projId" [routeParams]="this.routeParams">
                        </app-views-from-floors-list>
                    </li>
                    <li *ngIf="modulesArray[0].areaTitle && !unika">
                        <a (click)='openViewitemArea()' href='javascript:;'
                            class="menu-item title-button area-show"><span>{{ modulesArray[0].areaTitle }}</span></a>
                    </li>
                    <li *ngIf="modulesArray[0].constructionPointTitle && !unika">
                        <a (click)='openConstructionTrucing()' href='javascript:;'
                            class="menu-item title-button construction-show"><span>{{
                                modulesArray[0].constructionPointTitle }}</span></a>
                    </li>
                    <li *ngIf="modulesArray[0].linkToSiteTitle && !unika">
                        <a (click)='goToOwnerSite($event)' href='javascript:;'
                            class="menu-item title-button link-show"><span>{{ modulesArray[0].linkToSiteTitle
                                }}</span></a>
                    </li>

                    <!-- gallery -->
                    <!-- <li *ngIf="modulesArray[0].simulatorsTitle ||
                               modulesArray[0].simpleTitle ||
                               modulesArray[0].simple1Title ||
                               modulesArray[0].simple2Title ||
                               modulesArray[0].videoTitle ||
                               modulesArray[0].pdfTitle ||
                               modulesArray[0].simple3Title ||
                               showMenuDGalTrigger"> -->
                    <li *ngIf="allgalleries && !unika" class="gallery-holder-item" [class.dropdown]="compositeDesign">
                        <a (click)='showSubGalleryF($event)' [class.active]='this.showSubGallery' href='javascript:;'
                            class="menu-item title-button simulation-show"
                            [class.dropdown-title]="compositeDesign"><span>{{ 'GALLERY' | translate }}</span></a>
                        <div @slideUpMenu class="row sub-menu menu-build gallery-sub-menu"
                            [class.active]='this.showSubGallery' *ngIf='this.showSubGallery'>
                            <ul class="sub-menu-content">
                                <li *ngIf="modulesArray[0].simulatorsTitle">
                                    <a (click)="openSimple('progImages')" href='javascript:;'
                                        class="menu-item title-button simulation-show"
                                        [ngClass]="{'active': this.galleryType == 'progImages'}">
                                        <span>{{ modulesArray[0].simulatorsTitle }}</span></a>
                                </li>
                                <li *ngIf="modulesArray[0].simpleTitle">
                                    <a (click)='openSimple("simpleImage")' href='javascript:;'
                                        class="menu-item title-button construction-show"
                                        [ngClass]="{'active': this.galleryType == 'simpleImage'}"><span>{{
                                            modulesArray[0].simpleTitle }}</span></a>
                                </li>
                                <li *ngIf="modulesArray[0].simple1Title">
                                    <a (click)='openSimple("simpleImage1")' href='javascript:;'
                                        class="menu-item title-button construction-show"
                                        [ngClass]="{'active': this.galleryType == 'simpleImage1'}"><span>{{
                                            modulesArray[0].simple1Title }}</span></a>
                                </li>
                                <li *ngIf="modulesArray[0].simple2Title">
                                    <a (click)='openSimple("simpleImage2")' href='javascript:;'
                                        class="menu-item title-button construction-show"
                                        [ngClass]="{'active': this.galleryType == 'simpleImage2'}"><span>{{
                                            modulesArray[0].simple2Title }}</span></a>
                                </li>
                                <li *ngIf="modulesArray[0].videoTitle">
                                    <a (click)='openSimple("progVideo")' href='javascript:;'
                                        class="menu-item title-button video-show"
                                        [ngClass]="{'active': this.galleryType == 'progVideo'}"><span>{{
                                            modulesArray[0].videoTitle }}</span></a>
                                </li>
                                <li *ngIf="modulesArray[0].pdfTitle">
                                    <a (click)='openSimple("progPDF")' href='javascript:;'
                                        class="menu-item title-button pdf-show"
                                        [ngClass]="{'active': this.galleryType == 'progPDF'}"><span>{{
                                            modulesArray[0].pdfTitle }}</span></a>
                                </li>
                                <li *ngIf="modulesArray[0].simple3Title">
                                    <a (click)='openSimple("simpleImage3")' href='javascript:;'
                                        class="menu-item title-button construction-show"
                                        [ngClass]="{'active': this.galleryType == 'simpleImage3'}"><span>{{
                                            modulesArray[0].simple3Title }}</span></a>
                                </li>
                                <li>
                                    <div *ngIf="projUid" class="dynamic-gallery-in-menu">
                                        <app-n-menu-page-with-link (closeSubMenu)="closeSubMenu($event)"
                                            [galleryIdInput]=galleryIdInput [parentId]=projUid
                                            class="menu-view-page-with-link"></app-n-menu-page-with-link>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li *ngIf="projectlist && !unika">
                        <a href='javascript:;' (click)='navigatToMainPage()'
                            class="menu-item title-button project-list"><span>
                                {{ 'HOME-PAGE' | translate }} </span></a>
                    </li>
                </ul>
            </div>
            <div *ngIf="!this.modulesArray[0] && !unika">
                <ul class="gallery-without-modules">
                    <li class="home-page-spirikal">
                        <a (click)='goToProject()' href='javascript:;' class="menu-item title-button home-show"><span>
                                {{ 'PROJ-HOME-PAGE' | translate }}
                            </span></a>
                    </li>
                    <li *ngIf="!removeAllMenu">
                        <div *ngIf="projUid && showMenuDGalTrigger" class="dynamic-gallery-in-menu">
                            <app-n-menu-page-with-link [galleryIdInput]=galleryIdInput [parentId]=projUid
                                class="menu-view-page-with-link">
                            </app-n-menu-page-with-link>
                            <!-- <app-n-menu-page-with-link [galleryIdInput]=galleryIdInput [parentId]=projUid
                                class="menu-view-page-with-link"></app-n-menu-page-with-link> -->
                        </div>
                    </li>
                    <!-- <li *ngIf="this.compositeDesign" class="gallery-holder-item" [class.dropdown]="compositeDesign">
                        <a (click)='showSubGalleryF($event)' [class.active]='this.showSubGallery' href='javascript:;'
                            class="menu-item title-button simulation-show"
                            [class.dropdown-title]="compositeDesign"><span>{{ 'GALLERY' | translate }}</span></a>
                        <div @slideUpMenu class="row sub-menu menu-build gallery-sub-menu"
                            [class.active]='this.showSubGallery' *ngIf='this.showSubGallery'>
                            <ul class="sub-menu-content">
                                <li>
                                    <div *ngIf="projUid" class="dynamic-gallery-in-menu">
                                        <app-n-menu-page-with-link (closeSubMenu)="closeSubMenu($event)"
                                            [galleryIdInput]=galleryIdInput [parentId]=projUid
                                            class="menu-view-page-with-link"></app-n-menu-page-with-link>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li> -->
                    <li *ngIf="projectlist">
                        <a href='javascript:;' (click)=navigatToMainPage()
                            class="menu-item title-button project-list"><span>
                                {{ 'HOME-PAGE' | translate }} </span></a>
                    </li>
                </ul>
            </div>
            <!-- <div>
                <a href='javascript:;' (click)=navigatToMainPage() class="menu-item title-button project-list"><span>
                        {{ 'HOME-PAGE' | translate }} </span></a>
            </div> -->
            <!-- <ul>
                <li *ngIf="modulesArray[0].buildings">
                    <a (click)='openBuildings($event, "buildMenu")' href='javascript:;'
                        class="menu-item title-button building-show"><span>{{ modulesArray[0].buildingsTitle }}</span></a>
                    <div class="row sub-menu menu-build" [class.active]="showBuildingSubMenu">
                        <ul class="sub-menu-content">
                            <li *ngIf="this.zones">
                                <div *ngFor="let zone of this.zones  | sortNumber: 'title': true" class="zone">
                                    <div class="zone-holder">
                                        <h4 *ngIf="zone.title !== 'undefined'">{{ zone.title}}</h4>
                                        <div *ngFor="let list of zone.list | rankingNum: 'ranking'">
                                            <a href="javascript:;" (click)="viewBuildDetailsMenu($event, list)">
                                                <div class="title">
                                                    {{ list.name }}
                                                </div>
                                                <div class="text">
                                                    {{ list.freeText }}
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul> -->
        </div>
    </div>
    <div *ngIf="!showAdminButton"></div>
</div>